import { AuthenticatedTemplate } from '@azure/msal-react';

import { Login } from '../../Login.jsx'
import { useEffect } from "react";
import HomeBody from "./HomeBody";

export const HomeComponent = () => {
  useEffect(() => {
    document.title = 'Event Service';
  }, []);

  return (
    <div>
      <Login/>
      <AuthenticatedTemplate>
        <HomeBody />
      </AuthenticatedTemplate>
    </div>
  );
}

